// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media print {\n.d-print-4[data-v-383c2d6c] {\n\t\twidth: auto;\n}\n.d-print-8[data-v-383c2d6c] {\n\t\twidth: 100%;\n}\n.page-break[data-v-383c2d6c] {\n\t\tpage-break-before: always;\n\t\tvisibility: hidden;\n}\n}\n", ""]);
// Exports
module.exports = exports;
